exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px){.mobile-only[data-v-813f6304]{display:none !important}}@media (max-width: 1023px){.desktop-only[data-v-813f6304]{display:none !important}}[data-v-813f6304] .sf-bar__icon *[role=button]{cursor:pointer}\n", ""]);

// exports
